import { faBus } from "@fortawesome/pro-solid-svg-icons"
import { Box, Container, Grid, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import { ViewData, ViewToggler } from "components/ViewToggler/ViewToggler"
import { apiEndpoints } from "generated/apiEndpoints"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { StyledTableContainer } from "shared/styled/Global"
import { ServiceHistoryTable } from "./CheckHistoryTab/CheckHistoryTable"
import { InspectionSoonCard } from "./inspectionCard"
import UpcomingServicesTab from "./UpcomingChecksTab/UpcomingChecksTab"

enum ViewOption {
  Upcoming = "Upcoming",
  History = "History"
}

const getViewList = (t: any) => {
  return [
    { value: ViewOption.Upcoming, label: t("global.upcoming", "Upcoming") },
    { value: ViewOption.History, label: t("global.history", "History") },
  ]
}

const Checks = () => {
  const { t } = useTranslation()
  const [checksResult, checkApi] = useApi() as [IApiResult, IApiFunc]
  const viewList: ViewData[] = getViewList(t)
  const [view, setView] = useState(viewList[0].value)

  const fetchCategorizedInspections = useCallback(() => {
    checkApi.get(apiEndpoints.checktemplate.getcategorizedinspections.replace("{daysAhead}", "14"))
  }, [checkApi])

  useEffect(() => {
    fetchCategorizedInspections()
  }, [fetchCategorizedInspections])

  const bookedInspections = checksResult?.data?.bookedInspections
  const unbookedInspections = checksResult?.data?.unbookedInspections

  return (
    <>
      <Container>
        <Box mb={5}>
          <Typography variant="h1">{t("global.checks", "Checks")}</Typography>
        </Box>
        <Grid container direction="row" spacing={2}>
          <InspectionSoonCard
            status={checksResult?.status}
            icon={faBus}
            data={{
              booked: bookedInspections?.length,
              unbooked: unbookedInspections?.length
            }}
          />
        </Grid>
      </Container>
      <StyledTableContainer>
        {view === ViewOption.Upcoming ? (
          <UpcomingServicesTab
            viewList={viewList}
            view={view}
            setView={setView}
            onInspectionChange={fetchCategorizedInspections}
          />
        ) : (
          <ServiceHistoryTable
            viewList={viewList}
            view={view}
            setView={setView}
          />
        )}
      </StyledTableContainer>
    </>
  )
}

export default Checks
